import { useCallback, useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import { FallBackImage } from "@dpdgroupuk/mydpd-ui";

const ResponsiveImage = ({ alt, src, onClick }) => {
  const [dimensions, setDimensions] = useState({});

  const onLoadImage = useCallback(
    event => {
      setDimensions({
        width: event.target.naturalWidth,
        height: event.target.naturalHeight,
      });
    },
    [setDimensions]
  );

  const w100 = dimensions.width > dimensions.height;
  const h100 = dimensions.width < dimensions.height;
  return (
    <div className="image-helper" onClick={onClick}>
      <FallBackImage
        fluid
        alt={alt}
        src={src}
        onLoad={onLoadImage}
        className={classNames("d-block", {
          "h-100 mx-auto": h100,
          "w-100 my-auto py-sm": w100,
        })}
      />
    </div>
  );
};

ResponsiveImage.propTypes = {
  src: PropTypes.string,
  onClick: PropTypes.func,
  alt: PropTypes.string,
};

export default ResponsiveImage;
